// extracted by mini-css-extract-plugin
export default {"audio":"AudioButton_audio__B36Rr"};